import { store } from '../../store';
import { getUserId } from '../../store/slices/authSlice';
import {
    chatWasRemovedByOwner,
    getChatId,
    messageAddedInChat,
    setLastMessageInChatId,
    setShowReconnectAnimation
} from '../../store/slices/chatsSlice';
import LoggerService from '../LoggerService';
import WSServiceApi from './index';

const log = (msg, ...args) => {
    LoggerService.log('WebsocketActions: ' + msg, ...args);
};

export const WS_CHANNELS = {
    CHAT_SUBSCRIPTION: 'chat-subscription',
    CHAT_DISCONNECT: 'chat-disconnect',
    CHAT_DELETED: 'chat-deleted',
    CHAT_RENAME: 'chat-renamed',
    MESSAGE_ADD_IN_CHAT: 'message-add-in-chat',
    PING: 'ping',
    PONG: 'pong',
    CONNECTED: 'connected',
    LOGOUT: 'logout'
};

let unsubscribe = null;
class WebsocketActions {
    #lastActiveChatId = null;

    actions = {
        [WS_CHANNELS.MESSAGE_ADD_IN_CHAT]: (data) => {
            log('actions:MESSAGE_ADD_IN_CHAT');
            store.dispatch(messageAddedInChat(data.message));
        },
        [WS_CHANNELS.CHAT_DELETED]: () => {
            log('actions:CHAT_DELETED');
            store.dispatch(chatWasRemovedByOwner(true));
        },
        [WS_CHANNELS.LOGOUT]: () => {
            log('actions:LOGOUT');
            console.warn('USER: Logout');
            unsubscribe();
        }
    };

    constructor() {
        this.store = null;
        this.inited = false;
    }

    setActions() {
        Object.entries(this.actions).map(([key, value]) => {
            WSServiceApi.addAction(key, value);
        });
    }

    getActiveChatId() {
        const currentState = store.getState();
        return getChatId(currentState);
    }

    getActiveUserId() {
        const currentState = store.getState();
        return getUserId(currentState);
    }

    async changeChatSubscription(isForce = false) {
        if (!WSServiceApi.isInited || !WSServiceApi.ws) {
            return false;
        }
        log('changeChatSubscription:init');
        const userId = this.getActiveUserId();
        log('changeChatSubscription:user', { userId });
        if (!userId) {
            log('changeChatSubscription:user:NOT_FOUND', { userId });
            return false;
        }

        const activeChatID = this.getActiveChatId();
        log('changeChatSubscription:activeChat', { activeChatID });
        if (!isForce && this.#lastActiveChatId === activeChatID) {
            log('changeChatSubscription:activeChat:Equals', { activeChatID, isForce });
            return false;
        }

        if (this.#lastActiveChatId) {
            log('changeChatSubscription:activeChat:old', { old: this.#lastActiveChatId, new: activeChatID, isForce });
            WSServiceApi.send(WS_CHANNELS.CHAT_DISCONNECT, { chatId: this.#lastActiveChatId });
            this.#lastActiveChatId = null;
        }

        if (!activeChatID) {
            log('changeChatSubscription:activeChat:NOT_FOUND', { activeChatID });
            return false;
        }

        log('changeChatSubscription:activeChat:subscribe', { chatId: activeChatID });
        this.#lastActiveChatId = activeChatID;
        await WSServiceApi.sendWait(WS_CHANNELS.CHAT_SUBSCRIPTION, { chatId: activeChatID })
            .then((res) => {
                store.dispatch(setLastMessageInChatId(res?.chat?.lastMessageId || null));
                store.dispatch(setShowReconnectAnimation(false));
            })
            .catch((e) => {
                log('changeChatSubscription:activeChat:subscribe:ERROR', e, { chatId: activeChatID });
            });
        return true;
    }

    async onConnected() {
        this.#lastActiveChatId = null;
        await this.changeChatSubscription(true);
    }

    init() {
        if (this.inited) {
            return;
        }

        this.inited = true;
        this.setActions();
    }
}

const wsActions = new WebsocketActions();
unsubscribe = store.subscribe(async () => await wsActions.changeChatSubscription());
export default wsActions;
